import { UNIT_OPTIONS } from '../../shared/models/list';
import { Batch as OrderBatch } from '../../order/models/batch';

import { ClaimBatch } from './claim-batch';

export class QualityBatchLine {
	id?: number;
	reference = '';
	quantityValue = 0;
	quantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '';
	claimedQuantityValue = 0;
	claimedQuantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '';
	netWeight: number | undefined;
	grossWeight: number | undefined;
	dispatchDate: string | undefined;
	dispatchAdvice: string | undefined;
	claimBatch: ClaimBatch | undefined;
	orderBatch: OrderBatch | undefined;

	constructor(
		id: number,
		reference: string,
		quantityValue: number,
		claimedQuantityValue: number,
		quantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '',
		claimedQuantityUnitTr: keyof typeof UNIT_OPTIONS | '' = '',
		qtyBatchNet?: number,
		qtyBatchGross?: number,
		despatchAdviceNumber?: string,
		despatchAdviceDate?: string,
		claimBatch?: ClaimBatch
	) {
		this.id = id;
		this.reference = reference;
		this.quantityValue = quantityValue;
		this.quantityUnitTr = quantityUnitTr;
		this.claimedQuantityValue = claimedQuantityValue;
		this.claimedQuantityUnitTr = claimedQuantityUnitTr;
		this.netWeight = qtyBatchNet;
		this.grossWeight = qtyBatchGross;
		this.dispatchAdvice = despatchAdviceNumber;
		this.dispatchDate = despatchAdviceDate;
		this.claimBatch = claimBatch;
	}
}
